import { axiosWithCredentials } from "../api/axios";

/**
 * Silent re-auth invocation loop handler
 */
const refreshAccessToken = async (setAuth, setActivitySettings) => {
  //console.log("Executing background silent token refresh call...");

  try {
    // 🌟 HIT the route. Browser naturally attaches the secure HTTP cookie in transit
    const response = await axiosWithCredentials.get("/refresh");

    //console.log("Refresh verification response captured:", response.data);

    setAuth((prev) => ({
      ...prev,
      accessToken: response.data.accessToken,
      isProfileComplete: response.data.isProfileComplete,
      hasPendingPrepaidOrder: response.data.hasPendingPrepaidOrder,
      pendingOrderDetails: response.data.pendingOrderDetails,
      hasUnacknowledgedRedemption: response.data.hasUnacknowledgedRedemption,
    }));

    if (setActivitySettings && response.data.activitySettings) {
      setActivitySettings(response.data.activitySettings);
    }

    return {
      accessToken: response.data.accessToken,
      activitySettings: response.data.activitySettings,
      isProfileComplete: response.data.isProfileComplete,
      hasPendingPrepaidOrder: response.data.hasPendingPrepaidOrder,
      pendingOrderDetails: response.data.pendingOrderDetails,
      hasUnacknowledgedRedemption: response.data.hasUnacknowledgedRedemption,
    };
  } catch (error) {
    console.error("REFRESH_TOKEN_ERROR_DETAIL:", {
      message: error.message,
      status: error.response?.status,
    });
    return null; // Explicit fallback signaling down the stream chain
  }
};

export default refreshAccessToken;
